import { defineMessage } from 'services/localization';

export const messages = {
    emailRequired: defineMessage('your_email_address_is_required'),
    emailInvalid: defineMessage('the_email_address_is_not_valid'),
    emailPlaceholder: defineMessage('enter_your_email_address'),
    title: defineMessage('enter_your_business_email'),
    consentMarketingText: defineMessage('i_agree_to_receive_appr_ghts_and_special_offers'),
    signupButtonText: defineMessage('sign_up_for_free'),
    startTrial: defineMessage('start_a_free_day_trial'),
    advantageNoCreditCard: defineMessage('no_credit_card_required'),
    advantageUnlimitedUsers: defineMessage('unlimited_users'),
    advantagesCancel: defineMessage('cancel_at_any_time'),
};
